/*
 * Module for the Participant Home account locking menu
*/

rs.module("application/sections/participant/accountlockingmenu",

    ["controls/components/event-banner", "common/select-helper"],

    function (eventBanner, selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, codeValues) {

            var accountLocking = $.js(jsSelectors.accountLocking);

            // show/hide account locking menu when toggle button is clicked
            accountLocking.js(jsSelectors.toggle).click(function () {
                accountLocking.js(jsSelectors.menu).toggle();
            });

            // hide account locking menu if user clicks anywhere outside of it
            $("body").click(function (event) {
                if ($(event.target).closest(`[data-js~=${jsSelectors.accountLocking}`).length == 0) {
                    accountLocking.js(jsSelectors.menu).hide();
                }
            });

            var form = $.js(jsSelectors.form);

            form.js(jsSelectors.lockButton, { required: false }).click(function () {
                lockUnlockAccount(true);
            });

            form.js(jsSelectors.unlockButton, { required: false }).click(function () {
                lockUnlockAccount(false);
            });

            function lockUnlockAccount(lock) {

                if (form.valid()) {

                    // make the call to lock/unlock the account
                    $.ajax({
                        type: "POST",
                        url: backendUrls.lockUnlockAccount,
                        data: {
                            lockAccount: lock,
                            lockReason: form.js(jsSelectors.reasonSelect, {required: false}).val()
                        },
                        dataType: "text"

                    }).fail(function () {

                        accountLocking.js(jsSelectors.cancelButton, { multiple: true }).show();
                        form.js(jsSelectors.lockButton, { required: false }).blur();
                        form.js(jsSelectors.unlockButton, { required: false }).blur();

                    }).done(function (results) {

                        eventBanner.addInformationalMessages(`The account has been ${lock ? "locked" : "unlocked"}.`);

                        accountLocking.js(jsSelectors.cancelButton, { multiple: true }).hide();

                        var updateReasonSelectHelper = selectHelper.getHelper(accountLocking.js(jsSelectors.updateReasonSelect));
                        updateReasonSelectHelper.setValue(results.lockReason);

                        if (lock) {
                            accountLocking.js(jsSelectors.lockIcon).addClass(cssClasses.solid);

                            var updateReasonSelectHelper = selectHelper.getHelper(accountLocking.js(jsSelectors.updateReasonSelect));
                            updateReasonSelectHelper.setValue(results.lockReason);
                            accountLocking.js(jsSelectors.userName).html(results.displayName);
                            accountLocking.js(jsSelectors.lockDate).html(results.lockedDate);

                            accountLocking.js(jsSelectors.unlockedView).hide();
                            accountLocking.js(jsSelectors.lockedView).show();
                        }
                        else {
                            accountLocking.js(jsSelectors.lockIcon).removeClass(cssClasses.solid);

                            var reasonSelectHelper = selectHelper.getHelper(accountLocking.js(jsSelectors.reasonSelect));
                            reasonSelectHelper.setValue(codeValues.other);

                            accountLocking.js(jsSelectors.lockedView).hide();
                            accountLocking.js(jsSelectors.unlockedView).show();
                        }
                    });
                }
            }

            // Create a variable to hold the timeout for showing the saved message
            var savedMessageTimer;

            accountLocking.js(jsSelectors.updateReasonSelect).change(function () {

                $.post(
                    backendUrls.updateLockReason,
                    {
                        lockReason: form.js(jsSelectors.updateReasonSelect, { required: false }).val()
                    }
                ).done(function () {
                    accountLocking.js(jsSelectors.saveMessage).removeClass(cssClasses.failure);
                    accountLocking.js(jsSelectors.saveMessage).html("Saved");
                }).fail(function () {
                    accountLocking.js(jsSelectors.saveMessage).addClass(cssClasses.failure);
                    accountLocking.js(jsSelectors.saveMessage).html("Save Failed");
                }).always(function () {

                    // Each time the reason is updated, we want to reset the timeout for showing the saved message
                    clearTimeout(savedMessageTimer);

                    // Always hide the message first 
                    // In case it is already being shown for a previous save, we want it to "flash" to indicate a subsequent save
                    accountLocking.js(jsSelectors.saveMessage).removeClass(cssClasses.visible);

                    // Show the saved message (wait a split second before showing to allow for "flash" - see above)
                    setTimeout(function () {
                        accountLocking.js(jsSelectors.saveMessage).addClass(cssClasses.visible);
                    }, 200);

                    // Hide the message after 2 seconds
                    savedMessageTimer = setTimeout(function () {
                        accountLocking.js(jsSelectors.saveMessage).removeClass(cssClasses.visible);
                    }, 2000);
                });
            });

            // When cancel is clicked, clear errors and hide popup and cancel button
            accountLocking.js(jsSelectors.cancelButton, { multiple: true }).click(function () {

                eventBanner.removeAllMessages();
                accountLocking.js(jsSelectors.menu).hide();
                accountLocking.js(jsSelectors.cancelButton, { multiple: true }).hide();

                var reasonSelectHelper = selectHelper.getHelper(accountLocking.js(jsSelectors.reasonSelect));
                reasonSelectHelper.setValue(codeValues.other);               
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);